import React from 'react'
import { Sparkles } from 'lucide-react'
import advancedMaterials from '../Assests/thematic/Advanced Materials, Nanotechnology and Textiles.png'
import aiDataScience from '../Assests/thematic/AI, Machine Learning and Data Science.png'
import defenceSpace from '../Assests/thematic/Defence and Space Technology.png'
import energyClimate from '../Assests/thematic/Energy, Climate and Sustainability.png'
import fundamentalSciences from '../Assests/thematic/Fundamental Sciences and Mathematics.png'
import healthBiotech from '../Assests/thematic/Health, Biotechnology and Medical Devices.png'
import innovationPolicy from '../Assests/thematic/Innovation, Public Policy and Rural Development.png'
import opticsImaging from '../Assests/thematic/Optics, Photonics and Imaging.png'
import quantumTelecom from '../Assests/thematic/Quantum, Semiconductors and Telecom.png'
import roboticsIot from '../Assests/thematic/Robotics, IoT and Cyber Physical Systems.png'
import smartManufacturing from '../Assests/thematic/Smart Manufacturing and Design.png'
import waterTransport from '../Assests/thematic/Water, Transport and Urban Systems.png'

const thematicAreas = [
  ['01', 'Health, Biotechnology and Medical Devices', healthBiotech],
  ['02', 'AI, Machine Learning and Data Science', aiDataScience],
  ['03', 'Quantum, Semiconductors and Telecom', quantumTelecom],
  ['04', 'Optics, Photonics and Imaging', opticsImaging],
  ['05', 'Robotics, IoT and Cyber Physical Systems', roboticsIot],
  ['06', 'Advanced Materials, Nanotechnology and Textiles', advancedMaterials],
  ['07', 'Smart Manufacturing and Design', smartManufacturing],
  ['08', 'Energy, Climate and Sustainability', energyClimate],
  ['09', 'Defence and Space Technology', defenceSpace],
  ['10', 'Water, Transport and Urban Systems', waterTransport],
  ['11', 'Innovation, Public Policy and Rural Development', innovationPolicy],
  ['12', 'Fundamental Sciences and Mathematics', fundamentalSciences],
]

const ThematicAreas = () => (
  <main className="min-h-screen overflow-hidden bg-slate-50 pt-20 text-slate-900">
    <section className="relative px-4 py-20 sm:px-6 lg:px-8" aria-labelledby="thematic-title">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(125,211,252,0.28),_transparent_35%),radial-gradient(circle_at_bottom_left,_rgba(253,186,116,0.2),_transparent_30%)]" />
      <div className="relative mx-auto max-w-7xl">
        <div className="max-w-3xl">
          <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-cyan-200 bg-cyan-50 px-4 py-2 text-xs font-bold uppercase tracking-[0.28em] text-cyan-700">
            <Sparkles className="h-4 w-4" aria-hidden="true" /> Open House 2026
          </p>
          <h1 id="thematic-title" className="text-4xl font-black leading-tight text-slate-900 sm:text-6xl">Thematic Areas</h1>
          <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-600">Explore the ideas, technologies and people shaping the future at IIT Delhi.</p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {thematicAreas.map(([number, title, image]) => (
            <article key={number} className="group relative aspect-[3/2] overflow-hidden rounded-2xl border border-white/70 bg-slate-200 shadow-lg transition duration-500 hover:-translate-y-2 hover:border-cyan-300 hover:shadow-2xl hover:shadow-cyan-200/70 focus-within:-translate-y-2">
              <img src={image} alt={`${title} thematic area`} className="absolute inset-0 h-full w-full object-cover transition duration-700 ease-out group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/75 via-slate-950/5 to-transparent opacity-0 transition duration-500 group-hover:opacity-100" />
              <div className="absolute left-4 top-4 flex h-11 w-11 items-center justify-center rounded-xl border border-white/60 bg-white/90 text-sm font-black text-slate-900 shadow-lg backdrop-blur-sm transition duration-500 group-hover:scale-110 group-hover:bg-cyan-500 group-hover:text-white">
                {number}
              </div>
              <div className="absolute inset-x-4 bottom-4 translate-y-4 rounded-xl border border-white/20 bg-slate-950/80 p-3 text-white opacity-0 backdrop-blur-md transition duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                <p className="text-sm font-bold leading-tight">{title}</p>
                <p className="mt-1 text-xs uppercase tracking-widest text-cyan-200">Explore research area</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  </main>
)

export default ThematicAreas
